<div class="app-control-row row rule-container" [class.logic-rule-invalid]="rule._invalid">
  <div class="sm-space-y-2">
    <div class="sm-flex sm-items-center">
      <p i18n class="rule-title" data-test="title">
        <cc-badge [isInlineBadge]="true" text="Beta"></cc-badge>
        Approval Signature Logic
      </p>
      <a
        data-test="learn-more"
        i18n
        class="learn-more-helper"
        href="https://intercom.help/dashpivot/en/articles/8329198-approval-signature-logic"
        target="_blank"
        rel="noopener noreferrer"
      >
        <cc-banner
          bannerText="Learn more about Approval Signature Logic"
          icon="question"
          size="sm"
          type="helper"
        ></cc-banner>
      </a>

      <cc-banner
        data-test="warning-beta-banner"
        type="warning"
        size="sm"
        icon="warning"
        [bannerText]="betaWarningText"
        class="sm-font-medium"
      ></cc-banner>
    </div>

    <div class="form-inline sm-gap-1">
      <div class="sm-flex sm-gap-1 sm-items-center">
        <span>If</span>
        <div>
          <cc-search-and-select
            customClass="has-badge"
            data-test="logic-types"
            placeholder="Select..."
            i18n-placeholder="Select..."
            name="{{ dropdownNames.Type + '-' + rule._id }}"
            minWidth="200px"
            [items]="typesDropdowns"
            [(selected)]="selectedType"
            [invalid]="isRuleInvalid(dropdownNames.Type)"
            (change)="onInputChange($event, 'type'); rule._invalid && validateLogicRules()"
          ></cc-search-and-select>
          <span
            *ngIf="isRuleInvalid(dropdownNames.Type) && rule._invalidMessage"
            class="invalid-message"
          >
            {{ rule._invalidMessage }}
          </span>
        </div>
        <span>is</span>
        <div>
          <cc-search-and-select
            data-test="logic-operators"
            placeholder="Select..."
            i18n-placeholder="Select..."
            name="{{ dropdownNames.Operator + '-' + rule._id }}"
            minWidth="200px"
            [items]="operatorsDropdown"
            [(selected)]="selectedOperator"
            [invalid]="isRuleInvalid(dropdownNames.Operator)"
            [disabled]="!rule.type"
            (change)="onInputChange($event, dropdownNames.Operator); rule._invalid && validateLogicRules()"
          ></cc-search-and-select>
          <span
            *ngIf="isRuleInvalid(dropdownNames.Operator) && rule._invalidMessage"
            class="invalid-message"
          >
            {{ rule._invalidMessage }}
          </span>
        </div>
      </div>

      <div>
        <cc-search-and-select
          customClass="single-line no-clear-all-button {{ isSelectedValuesMultiple ? 'height-auto' : '' }}"
          data-test="logic-values"
          name="{{ dropdownNames.Values + '-' + rule._id }}"
          placeholder="Select..."
          i18n-placeholder="Select..."
          minWidth="200px"
          maxWidth="200px"
          [items]="valuesDropdown"
          [(selected)]="selectedValues"
          [clearable]="rule.operator === logicOperators.Equals"
          [multiple]="rule.operator === logicOperators.Equals"
          [disabled]="!rule.type || !rule.operator"
          [invalid]="isRuleInvalid(dropdownNames.Values)"
          (change)="onInputChange($event, dropdownNames.Values); rule._invalid && validateLogicRules()"
        ></cc-search-and-select>
        <span
          *ngIf="isRuleInvalid(dropdownNames.Values) && rule._invalidMessage"
          class="invalid-message"
        >
          {{ rule._invalidMessage }}
        </span>
      </div>
      <div class="sm-flex sm-gap-1 sm-items-center">
        <span>allow</span>

        <div>
          <cc-search-and-select
            customClass="has-badge"
            data-test="logic-actions"
            placeholder="Select..."
            i18n-placeholder="Select..."
            name="{{ dropdownNames.Action + '-' + rule._id }}"
            minWidth="200px"
            [items]="actionsDropdown"
            [selected]="selectedAction"
            [invalid]="isRuleInvalid(dropdownNames.Action)"
            (change)="onInputChange($event, dropdownNames.Action); rule._invalid && validateLogicRules()"
          ></cc-search-and-select>

          <span
            *ngIf="isRuleInvalid(dropdownNames.Action) && rule._invalidMessage"
            class="invalid-message"
          >
            {{ rule._invalidMessage }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <cc-field-action type="delete" (onClick)="onDeleteRule()"></cc-field-action>
</div>
